import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  onCreate: () => void;
}

export const CreateAccountWidget: React.FC<Props> = ({ onCreate }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" my={2}>
      <Typography variant="body1">Don't have an account?</Typography>
      <Button
        onClick={() => {
          onCreate();
        }}
        variant="contained"
        color="secondary"
        data-testid="widgetCreateAccountButton"
      >
        Let's Get Started &nbsp;
        <FontAwesomeIcon icon="chevron-double-right" />
      </Button>
    </Box>
  );
};
